export default __webpack_public_path__ + "static/media/logout.0fd79d0e.jpeg";